import { render, staticRenderFns } from "./consultationChoice.vue?vue&type=template&id=7316d564&scoped=true"
import script from "./consultationChoice.vue?vue&type=script&lang=js"
export * from "./consultationChoice.vue?vue&type=script&lang=js"
import style0 from "./consultationChoice.vue?vue&type=style&index=0&id=7316d564&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7316d564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7316d564')) {
      api.createRecord('7316d564', component.options)
    } else {
      api.reload('7316d564', component.options)
    }
    module.hot.accept("./consultationChoice.vue?vue&type=template&id=7316d564&scoped=true", function () {
      api.rerender('7316d564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/wenzhen/consultationChoice.vue"
export default component.exports